<template>
  <div>
      <div class="header">
        <div class="center">
          <a href="https://tizdata.com/" target="blank">
            <img src="@/assets/image/logobA.png" style="transform: translateY(0.625rem);" alt="">
          </a>
          <router-link to="/"><span>课程中心</span></router-link> 
          <!-- <router-link to="/help"><span>帮助文档</span></router-link>  -->
          <a href="https://doc.tizdata.com/" target="_blank"><span>文档中心</span></a>
          <a href="https://tizdata.com/bidownload/" target="_blank"><span>产品下载</span></a>
          <div class="right_img" v-if="lgstatus" style="transform: translateY(-0.4325rem);">
            <el-dropdown :hide-on-click="true">
              <div class="right_hover" >
                <div class="img_border">
                  <img :src="userImg" alt="">
                </div>
              <span>{{phone}}</span></div>
                <el-dropdown-menu slot="dropdown" style="margin-right:5.625rem">
                    <el-dropdown-item @click.native="goUser()">个人中心</el-dropdown-item>
                    <el-dropdown-item @click.native="goOut()">退出登录</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="right_img" v-else>
            <button class="btn1" @click="login">登录</button>
            <!-- <a href="https://www.5ifbi.com/" class="btn2">立即使用</a> -->
            <a href="https://help.tizdata.com/" class="btn2">立即使用</a>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
  export default{
    name:'Header',
    data(){
      return {
        lgstatus: true,   //登录按钮和信息展示的控制
        childmsg: true,
        userImg:'',     //用户头像
        phone:''   //手机号
      }
    },
    mounted(){
      this.getImg()
      this.getPhone()
      console.log('你是谁啊')
    },
    methods: {
      getImg(){  //获取用户头像和电话号
        console.log(JSON.stringify(localStorage.getItem('avatar')));
        console.log(localStorage.getItem('avatar'));
        this.userImg = localStorage.getItem('avatar')!='null'?localStorage.getItem('avatar'):'https://help.tizdata.com/newdoc/image/email/Avatar.png'
      },
      getPhone(){  //获取用户头像和电话号
        this.phone = localStorage.getItem('phone')
      },
      login() {
        this.childmsg = true
        this.$emit('parentmsg', this.childmsg)
        this.$router.push('/login')
      },
      register() {
        this.childmsg = false
        this.$emit('parentmsg', this.childmsg)
        this.$router.push('/register')
      },
      goUser(){
        this.$router.push('/user')   //跳转到个人中心
      },
      goOut(){
        localStorage.removeItem('token')
        this.$router.go(0)
      }
    },
    created() {
      this.getImg()
      if (localStorage.getItem('token')) {
        return (this.lgstatus = true)
      }
      return (this.lgstatus = false)
    },
  }
  </script>
  
  <style scoped lang="less">
  .header{
    overflow: hidden;
    position: fixed;
    top: 0;
    left: 0;
   
    // width: 1200px;
    // min-width: 1200px;
    // max-width: 1920px;
    width: 100%;
    height: 60px;
    background-color: #fff;
    z-index: 999;
    z-index: 9999999;
    margin: 0 auto;
    line-height: 60px;
    border: none;
  
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.05);
    .center{
      width: 1200px;
      min-width: 1200px;
      max-width: 1920px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      img{
        width: 137px;
        height: 39px;
        margin-right: 60px;
      }
      span{
        margin-right: 55px;
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        color: #2B3361;
  
      }
      .right_img{
        // margin-left: 880px;
        position: fixed;
        right: 150px;
        top: 18px;
        display: flex;
        align-items: center;
        .right_hover{
          display: flex;
          align-items: center;
          justify-content: start;
          .img_border{
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background-color: aliceblue;
          margin-right: 8px;
          img{
            width: 100%;
            height: 100%;
            line-height: 100%;
            border-radius: 50%;
          }
          span{
            font-weight: 400;
            font-size: 16px;
            color: #2B3361;
            line-height: 60px;
            text-align: center;
            line-height: 30px;
          }
        }
        }
  
        .btn1{
          width: 84px;
          height: 32px;
          border: 1px solid #0287FF;
          border-radius: 4px;
          font-weight: 400;
          font-size: 14px;
          background: #FFFFFF;
          line-height: 20px;
          border: 1px solid #0287FF;
          display: flex;
          align-items: center;
          color: #0287FF;
          justify-content: center;
          margin-right: 8px;
        }
        .btn2{
          width: 84px;
          height: 32px;
          border: 1px solid #FFFFFF;
          background-color: #0287FF;
          justify-content: center;
          border-radius: 4px;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          border: 1px solid #0287FF;
          display: flex;
          align-items: center;
          color: #FFFFFF;
        }
      }
    }
  }
  </style>
  
  <style>
    .el-dropdown-link {
      cursor: pointer !important;
      color: #409EFF;
    }
    .el-icon-arrow-down {
      font-size: 12px;
    }
  </style>
  